import {Observable, Subscription} from 'rxjs';

import IFrameStore from '../Interfaces/IFrameStore';

const subscribeToCaptionsMenuButtonTap = (
    captionsMenuButtonTap$: Observable<void>,
    frameStore: IFrameStore
): Subscription =>
    captionsMenuButtonTap$
        .subscribe(() => frameStore.actions.openSettings());

export default subscribeToCaptionsMenuButtonTap;